import { useState, useEffect } from 'react';
import { adminGetSupportHours, adminSetSupportHours } from '../api/supportHoursApi';

const DAYS_OF_WEEK = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
];

const DEFAULT_HOURS = {
  enabled: true,
  start: '09:00',
  end: '17:00'
};

const DEFAULT_SUPPORT_HOURS = DAYS_OF_WEEK.reduce((acc, day) => ({
  ...acc,
  [day.toLowerCase()]: { ...DEFAULT_HOURS }
}), {});

export const useSupportHours = () => {
  const [hours, setHours] = useState(DEFAULT_SUPPORT_HOURS);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSupportHours = async () => {
      try {
        const storedHours = await adminGetSupportHours();
        setHours(storedHours && Object.keys(storedHours).length ? storedHours : DEFAULT_SUPPORT_HOURS);
      } catch (err) {
        console.error('Error fetching support hours:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSupportHours();
  }, []);

  const updateSupportHours = async (newHours) => {
    try {
      await adminSetSupportHours(newHours);
      setHours(newHours);
      return true;
    } catch (err) {
      console.error('Error updating support hours:', err);
      setError(err.message);
      return false;
    }
  };

  const isWithinSupportHours = () => {
    const now = new Date();
    const currentDay = now.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
    const currentTime = now.toLocaleTimeString('en-US', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit'
    });

    const dayHours = hours?.[currentDay];
    if (!dayHours) return false;

    return Boolean(dayHours.enabled) &&
      currentTime >= dayHours.start &&
      currentTime <= dayHours.end;
  };

  return {
    hours,
    loading,
    error,
    updateSupportHours,
    isWithinSupportHours
  };
}; 